import Utils from "@/utils";
import Response from "@/models/checkRequest/response";
export default class Request {
  url: string;
  httpMethod: string;
  id: string;
  hasResults: boolean;
  isPending: boolean;
  isReady: boolean;
  results: Array<Response>;

  constructor(url?: string, httpMethod?: string, schemeToAdd?: string) {
    this.url = url ? url.trim() : "";
    this.url = Utils.ConvertHostnameToLowercase(this.url);

    this.httpMethod = httpMethod || "";
    this.id = Utils.GenerateUniqueId();
    this.hasResults = false;

    schemeToAdd && this.url
      ? (this.url = Utils.TryAddScheme(this.url, schemeToAdd))
      : this.url;

    this.isPending = false;
    this.isReady = false;
    this.results = [];
  }

  get isValid(): boolean {
    return this.url ? Utils.ValidateUrl(this.url) : false;
  }
}
